export namespace PaymentAccountStatusConstants {
  export const NEW = 'new';
  export const PROCESSOR_ACCEPTED = 'processor accepted';
  export const PROCESSOR_REJECTED = 'processor rejected';
  export const PROCESSOR_DELETED = 'processor deleted';
  export const EXPIRED = 'expired';
}
